import { attr, belongsTo } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const ProductFeedback = ApplicationRecord.extend({
  attrs: {
    product_id: attr({ type: Number }),
    customer_id: attr({ type: Number }),
    description: attr(),
    rating: attr({ type: Number }),
    created_at: attr({ persist: false }),
    updated_at: attr({ persist: false }),
  },
  static: {
    endpoint: '/product_feedbacks',
    jsonapiType: 'shop-product_feedbacks',
  },
});

export default ProductFeedback;
